import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import { renderClasses } from "utils/renderClasses"
import { BaseTypeProps } from "../props"
import "./heading5.scss"

const Heading5 = forwardRef(
  ({ children, className, italic = false, semiBold = false }, ref) => (
    <h5
      className={renderClasses("g-heading-tag g-heading5", [
        [className, className],
        [italic, "-i"],
        [semiBold, "-s"],
      ])}
      ref={ref}
    >
      {children}
    </h5>
  )
)

Heading5.props = {
  ...BaseTypeProps,
  semiBold: PropTypes.bool,
}

Heading5.displayName = "Heading5"

Heading5.propTypes = Heading5.props

export default Heading5
